import Indicators from './Indicators';

export default Indicators;
